export const examLinkName = location.origin.includes("kaoshi") ? "new-login" : "login"
